<template>
  <a-card
    :bordered="false"
    class="header-solid h-full mb-40"
    :bodyStyle="{ paddingTop: '12px' }"
  >
    <template #title>
      <a-row class="mb-0" type="flex" align="middle">
        <a-col :span="24" :md="20">
          <h6>History of entering and leaving the building</h6>
        </a-col>
      </a-row>
    </template>
    <a-tabs class="mt-0" default-active-key="1">
      
      <a-tab-pane v-if="!this.$store.state.role.RulesUser.roles.includes('student')" key="1" tab="Time Attandance ( for staff )" force-render>
        <attandance />
      </a-tab-pane>
    </a-tabs>
  </a-card>
</template>

<script>
import buildaccess from "./bulidaccess.vue";
import attandance from "./timeattandance.vue";
export default {
  components: {
    buildaccess,
    attandance
  },
  data() {
    return {};
  },
};
</script>
